import { GridLayoutHeader } from '../../../../../constants';
import { FlexLayout } from '../../../../../components/layout/FlexLayout';
import { FormatTextBox } from '../../../../../components/forms/FormatTextBox';
import { FormatNumberTextBox } from '../../../../../components/forms/FormatNumberTextBox';
import { Sum } from '../../../../../utils/array';
import { Format } from '../../../../../utils/string';
import { StockStatement } from '../StockStatement';
import { DayModel } from '../models';

const Day: GridLayoutHeader<DayModel, StockStatement>[] = [
  {
    id: 'ibgdate',
    text: '입고일자',
    width: 140,
    trail: () => (
      <FlexLayout
        justify="center"
        align="center"
      >
        합 계
      </FlexLayout>
    ),
    render: (x) => (
      <FormatTextBox
        textAlign="center"
        format="####-##-##"
        value={x.ibgdate}
      />
    ),
  },
  {
    id: 'ibgnum',
    text: '번호',
    width: 70,
    render: (x) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {x.ibgnum}
      </FlexLayout>
    ),
  },
  {
    id: 'ibgseq',
    text: '순번',
    width: 70,
    render: (x) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {x.ibgseq}
      </FlexLayout>
    ),
  },
  {
    id: 'projnm',
    text: '프로젝트',
    width: 200,
    render: (x) => (
      <FlexLayout
        justify="left"
        align="center"
      >
        {x.projnm}
      </FlexLayout>
    ),
  },
  {
    id: 'cltnm',
    text: '거래처명',
    width: 200,
    render: (x) => (
      <FlexLayout
        justify="left"
        align="center"
      >
        {x.cltnm}
      </FlexLayout>
    ),
  },
  {
    id: 'pernm',
    text: '담당자',
    width: 100,
    render: (x) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {x.pernm}
      </FlexLayout>
    ),
  },
  {
    id: 'myn',
    text: '유무상',
    width: 70,
    render: (x) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {x.myn === '1' ? '유상' : x.myn === '0' ? '무상' : x.myn === '2' ? 'FM' : ''}
      </FlexLayout>
    ),
  },
  {
    id: 'pcode',
    text: '품목코드',
    render: (x) => (
      <FlexLayout
        justify="left"
        align="center"
      >
        {x.pcode}
      </FlexLayout>
    ),
  },
  {
    id: 'pname',
    text: '품목명',
    width: 200,
    render: (x) => (
      <FlexLayout
        justify="left"
        align="center"
      >
        {x.pname}
      </FlexLayout>
    ),
  },
  {
    id: 'psize',
    text: '규격',
    width: 150,
    render: (x) => (
      <FlexLayout
        justify="left"
        align="center"
      >
        {x.psize}
      </FlexLayout>
    ),
  },
  {
    id: 'punit',
    text: '단위',
    width: 70,
    render: (x) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {x.punit}
      </FlexLayout>
    ),
  },
  {
    id: 'pserial',
    text: '품목시리얼번호',
    width: 100,
    render: (x) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {x.pserial}
      </FlexLayout>
    ),
  },
  {
    id: 'qty',
    text: '수량',
    width: 70,
    trail: (_, scope) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {scope?.state.qty_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {x.qty}
      </FlexLayout>
    ),
  },
  {
    id: 'balqty',
    text: '발주수량',
    width: 70,
    trail: (_, scope) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {scope?.state.balqty_tot}
      </FlexLayout>
    ),
    render: (x) => (
      <FlexLayout
        justify="center"
        align="center"
      >
        {x.balqty}
      </FlexLayout>
    ),
  },
  {
    id: 'actnm',
    text: '현장명',
    width: 200,
    render: (x) => (
      <FlexLayout
        justify="left"
        align="center"
      >
        {x.actnm}
      </FlexLayout>
    ),
  },
  {
    id: 'uamt',
    text: '단가',
    width: 70,
    render: (x) => (
      <FormatNumberTextBox
        char={','}
        charAt={3}
        textAlign="right"
        value={x.uamt}
      />
    ),
  },
  {
    id: 'samt',
    text: '공급금액',
    width: 70,
    trail: (data) => {
      const sumSamt = Sum.all(data, 'samt');
      return (
        <FlexLayout
          justify="right"
          align="center"
        >
          {Format.number(String(sumSamt))}
        </FlexLayout>
      );
    },
    render: (x) => (
      <FormatNumberTextBox
        char={','}
        charAt={3}
        textAlign="right"
        value={x.samt}
      />
    ),
  },
  {
    id: 'tamt',
    text: '부가세',
    width: 70,
    trail: (data) => {
      const sumTamt = Sum.all(data, 'tamt');
      return (
        <FlexLayout
          justify="right"
          align="center"
        >
          {Format.number(String(sumTamt))}
        </FlexLayout>
      );
    },
    render: (x) => (
      <FormatNumberTextBox
        char={','}
        charAt={3}
        textAlign="right"
        value={x.tamt}
      />
    ),
  },
  {
    id: 'mamt',
    text: '합계',
    width: 70,
    trail: (data) => {
      const sumMamt = Sum.all(data, 'mamt');
      return (
        <FlexLayout
          justify="right"
          align="center"
        >
          {Format.number(String(sumMamt))}
        </FlexLayout>
      );
    },
    render: (x) => (
      <FormatNumberTextBox
        char={','}
        charAt={3}
        textAlign="right"
        value={x.mamt}
      />
    ),
  },
  {
    id: 'bigo',
    text: '비고',
    width: 200,
    render: (x) => (
      <FlexLayout
        justify="left"
        align="center"
      >
        {x.bigo}
      </FlexLayout>
    ),
  },
];
export default Day;
